import React, { useState } from "react";
import LiveStatisticCard from "../LiveStatisticCard";
import LiverSearcher from "./LiverSearcher";
import { Rnd } from "react-rnd";
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@heroui/react";

function LiveStatisticWidget(props) {
	const [isOpen, setIsOpen] = useState(false);
	const [showConfig, setShowConfig] = useState(false);

	const handleContextMenu = (e) => {
		e.preventDefault();
		setIsOpen(true);
	};

	return (
		<>
			<Modal isOpen={showConfig} onClose={() => setShowConfig(false)}>
				<ModalContent>
					<ModalHeader>配置</ModalHeader>
					<ModalBody>
						<LiverSearcher
							onAnchorSelect={(e) => {
								props.onAnchorSelect(e);
							}}
						/>
					</ModalBody>
				</ModalContent>
			</Modal>

			<Rnd dragHandleClassName="drag-handle">
				<div className="relative group w-full h-full">
					<div
						className="drag-handle absolute top-2 right-2 w-6 h-6 border-2 border-dashed border-default-400 rounded-md cursor-move z-50 flex items-center justify-center bg-background/50 backdrop-blur-sm opacity-50 hover:opacity-100 transition-opacity"
						title="拖拽此处"
					>
						<span className="text-default-400 text-xs pointer-events-none">
							✥
						</span>
					</div>
					<Popover
						isOpen={isOpen}
						onOpenChange={setIsOpen}
						shouldCloseOnInteractOutside={() => true}
					>
						<PopoverTrigger>
							<div
								onContextMenu={handleContextMenu}
								className="w-full h-full"
							>
								<LiveStatisticCard
									item={props}
									showUser={true}
									onClick={props.onClick}
								/>
							</div>
						</PopoverTrigger>

						<PopoverContent>
							<Dropdown>
								<DropdownMenu>
									<DropdownItem
										key="settings"
										onClick={() => {
											setShowConfig(true);
											setIsOpen(false);
										}}
									>
										设置
									</DropdownItem>
									<DropdownItem
										key="delete"
										color="danger"
										onClick={props.onAnchorRemove}
									>
										删除
									</DropdownItem>
									<DropdownItem
										key="cancel"
										onClick={() => setIsOpen(false)}
									>
										取消
									</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</PopoverContent>
					</Popover>
				</div>
			</Rnd>
		</>
	);
}

export default LiveStatisticWidget;
